import { Inject, Injectable, Output, EventEmitter } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { AdalService } from '../shared/azure-authentication/adal.service';
import { BaseEndpoint } from '../app.constants';
import { Team } from '../teams/team.model';
import { User } from '../users/user.model';
import { Persona } from './persona.model';

@Injectable()
export class PersonaService {
    private personas: Persona[] = [];
    @Output() requestAdded: EventEmitter<any[]> = new EventEmitter<any[]>();

    constructor(private http: Http, @Inject(BaseEndpoint) private baseApiUrl, private adalService: AdalService) {
    }

    getPersonas(): Promise<Persona[]> {
        var url = this.baseApiUrl + 'v1/personas';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                this.personas = resp.json().body as Persona[];
                return this.personas;
            })
            .catch(this.handleError);
    }

    getPersonasCache(): Promise<Persona[]> {
        if (this.personas.length == 0) {
            return this.getPersonas();
        }
        else {
            var promise = new Promise<Persona[]>((resolve, reject) => {
                resolve(this.personas);
            });
            return promise;
        }
    }

    getTeamPersonas(teamId: string): Promise<Persona[]> {
        var url = this.baseApiUrl + 'v1/team/' + teamId + '/personas';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                var teams = resp.json().body as Persona[];
                return teams;
            })
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/personas/persona.service.ts